var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProductNew(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1003_801)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.3286 19.3858C15.7785 19.3858 19.3858 15.7785 19.3858 11.3286C19.3858 6.87879 15.7785 3.27148 11.3286 3.27148C6.87879 3.27148 3.27148 6.87879 3.27148 11.3286C3.27148 15.7785 6.87879 19.3858 11.3286 19.3858Z",
    stroke: "#1E1E1E",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.0225 17.0225L20.7287 20.7287",
    stroke: "#1E1E1E",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.30078 10.4538C7.30078 9.79787 7.83254 9.26611 8.4885 9.26611H14.1698C14.8257 9.26611 15.3575 9.79787 15.3575 10.4538V13.8332C15.3575 14.4891 14.8257 15.0209 14.1698 15.0209H8.4885C7.83254 15.0209 7.30078 14.4891 7.30078 13.8332V10.4538Z",
    stroke: "#1E1E1E",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.60254 8.99215V8.30721C9.60254 7.56558 10.2037 6.96436 10.9454 6.96436H11.7125C12.4542 6.96436 13.0554 7.56558 13.0554 8.30721V8.99215",
    stroke: "#1E1E1E",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1003_801"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(2 2)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProductNew);
export default __webpack_public_path__ + "static/media/ProductNew.43a880ed15c264ed4817697c23690ad8.svg";
export { ForwardRef as ReactComponent };